import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() pagesCount: number;
  @Input() page: number;
  @Output() pageChange: EventEmitter<number>;

  constructor() {
    this.pageChange = new EventEmitter<number>();
  }

  ngOnInit(): void {
  }

  get isPreviousDisabled(): boolean {
    return this.page === 1;
  }

  get isNextDisabled(): boolean {
    return this.page === this.pagesCount;
  }

  previousClick() {
    this.pageChange.next(this.page - 1);
  }

  nextClick() {
    this.pageChange.next(this.page + 1);
  }
}
